import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
	margin-bottom: 16px;
	max-height: 320px;
	overflow-y: auto;
	padding-right: 4px;

	&::-webkit-scrollbar {
		width: 8px;
	}

	&::-webkit-scrollbar-track {
		background: ${({ theme }) => theme.gray[100]};
		border-radius: 4px;
	}

	&::-webkit-scrollbar-thumb {
		background: ${({ theme }) => theme.gray[400]};
		border-radius: 4px;
	}
`;

export const Row = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	padding: 6px 8px;
	border-radius: 6px;
	background-color: ${({ theme }) => theme.gray[100]};
	height: 36px;
	box-sizing: border-box;
`;

export const RowLabel = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 13px;
	color: ${({ theme }) => theme.gray[1000]};
	min-width: 0;
	flex: 1;
`;

export const Email = styled.span`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const YouTag = styled.span`
	color: ${({ theme }) => theme.gray[600]};
	font-size: 12px;
`;

export const RowAction = styled.button`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	padding: 0;
	border: none;
	background: transparent;
	color: ${({ theme }) => theme.gray[700]};
	border-radius: 4px;

	&:hover {
		background-color: ${({ theme }) => theme.gray[400]};
		color: ${({ theme }) => theme.gray[1000]};
	}

	&:disabled {
		opacity: 0.5;
	}
`;

